import { SHOW_LOADER } from './constants';

const initialState = {
  show: false,
};

const loader = (state: any = initialState, action: any) => {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        msg: action.data.msg,
        show: action.data.show,
      };
    default:
      return state;
  }
};

export default loader;
